const _c0 = [[["", "page-header", ""]], [["", "page-content", ""]], [["", "page-footer", ""]]];
const _c1 = ["[page-header]", "[page-content]", "[page-footer]"];
const _c2 = a0 => ({
  "default-padding": a0
});
var PageContentLayoutComponent_1;
import { __decorate } from "tslib";
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConstructorName } from '../../shared';
import * as i0 from "@angular/core";
import * as i1 from "../../shared";
import * as i2 from "@angular/common";
let PageContentLayoutComponent = class PageContentLayoutComponent {
  static {
    PageContentLayoutComponent_1 = this;
  }
  monitoringService;
  useDefaultPadding = true;
  constructor(monitoringService) {
    this.monitoringService = monitoringService;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', PageContentLayoutComponent_1), 'constructor');
  }
  static ɵfac = function PageContentLayoutComponent_Factory(t) {
    return new (t || PageContentLayoutComponent)(i0.ɵɵdirectiveInject(i1.MonitoringService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PageContentLayoutComponent,
    selectors: [["geaui-page-content-layout"]],
    inputs: {
      useDefaultPadding: "useDefaultPadding"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c1,
    decls: 7,
    vars: 3,
    consts: [[1, "page-content-layout"], [1, "geaui-page-header"], [1, "geaui-page-content", 3, "ngClass"], [1, "geaui-page-footer"]],
    template: function PageContentLayoutComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵprojection(6, 2);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2, ctx.useDefaultPadding));
      }
    },
    dependencies: [CommonModule, i2.NgClass],
    styles: [".page-content-layout[_ngcontent-%COMP%]{position:relative;overflow-x:hidden;display:flex;flex-direction:column;height:100%}.page-content-layout[_ngcontent-%COMP%]   .geaui-page-content[_ngcontent-%COMP%]{flex:1;overflow:auto}.page-content-layout[_ngcontent-%COMP%]   .geaui-page-content.default-padding[_ngcontent-%COMP%]{padding:40px 0}"]
  });
};
PageContentLayoutComponent = PageContentLayoutComponent_1 = __decorate([ConstructorName('PageContentLayoutComponent')], PageContentLayoutComponent);
export { PageContentLayoutComponent };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageContentLayoutComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-page-content-layout',
      standalone: true,
      imports: [CommonModule],
      template: "<div class=\"page-content-layout\">\n  <div class=\"geaui-page-header\">\n    <ng-content select=\"[page-header]\"></ng-content>\n  </div>\n  <div class=\"geaui-page-content\" [ngClass]=\"{ 'default-padding': useDefaultPadding }\">\n    <ng-content select=\"[page-content]\"></ng-content>\n  </div>\n  <div class=\"geaui-page-footer\">\n    <ng-content select=\"[page-footer]\"></ng-content>\n  </div>\n</div>\n",
      styles: [".page-content-layout{position:relative;overflow-x:hidden;display:flex;flex-direction:column;height:100%}.page-content-layout .geaui-page-content{flex:1;overflow:auto}.page-content-layout .geaui-page-content.default-padding{padding:40px 0}\n"]
    }]
  }], () => [{
    type: i1.MonitoringService
  }], {
    useDefaultPadding: [{
      type: Input
    }]
  });
})();
